<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
        <ContentOrLoading>
            <b-row v-if="!loading">
                <b-col cols="12">
                    <FormInput label="Asunto:" type="text" rules="required" name="asunto" :infoText="infoText" :maxlength="60" v-model="boletinLocal.asunto" />
                </b-col>
                <b-col cols="12" class="mt-2" v-if="remitentes?.data?.length > 0">
                    <div class="form-group">
                        <label for="remitentes">Remitentes:</label>
                        <ValidationProvider name="remitente" rules="required" v-slot="{ errors }">
                            <multiselect
                                v-model="boletinLocal.remitente"
                                placeholder="Selecciona un remitente"
                                label="nombre"
                                track-by="id"
                                :options="remitentes.data"
                                :allow-empty="false"
                            />
                            <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold">
                                {{ errors[0] }}
                            </span>
                        </ValidationProvider>
                    </div>
                </b-col>
                <b-col cols="12" class="mt-2" v-if="carpetas?.data?.length > 0">
                    <div class="form-group">
                        <label for="carpetas">Carpetas:</label>
                        <ValidationProvider name="carpetas" rules="" v-slot="{ errors }">
                            <multiselect
                                v-model="boletinLocal.carpetas_comunicados"
                                placeholder="Selecciona uno o mas carpetas"
                                label="nombre"
                                track-by="id"
                                :options="carpetas.data"
                                :allow-empty="false"
                                :multiple="true"
                            />
                            <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold">
                                {{ errors[0] }}
                            </span>
                        </ValidationProvider>
                    </div>
                </b-col>
                <b-col cols="12" class="mt-2" v-if="grupos?.data?.length > 0">
                    <div class="form-group">
                        <label for="grupos">Enviar a:</label>
                        <ValidationProvider name="grupos" rules="required" v-slot="{ errors }">
                            <multiselect
                                v-model="boletinLocal.grupos"
                                placeholder="Selecciona uno o mas subscriptores"
                                label="nombre"
                                track-by="id"
                                :options="grupos.data"
                                :allow-empty="false"
                                :multiple="true"
                            />
                            <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold">
                                {{ errors[0] }}
                            </span>
                        </ValidationProvider>
                    </div>
                </b-col>
                <b-col cols="12" class="mt-2 text-right">
                    <button id="continuar" class="button" type="submit" :disabled="loading">
                        <span>Continuar</span>
                    </button>
                </b-col>
            </b-row>
        </ContentOrLoading>
    </ValidationObserver>
</template>

<script>
    import apiService from '@/services/api-comunicados';

    export default {
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            boletin: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                remitentes: null,
                carpetas: null,
                grupos: null,
                boletinLocal: { ...this.boletin },
                infoText: `
                <strong>Recomendaciones para el asunto</strong></br>
                <p class="mt-2">- Intente mantener el asunto pequeño, si posible, abajo de 60 caracteres.</p>
                <p>- No utilice solo letras mayúsculas.</p>
                <p class="mb-2">- Está bien usar emojis pero evita usar más de uno.</p>
            `
            }
        },
        methods: {
            async getRemitentes() {
                try {
                    this.remitentes = await apiService.getRemitentes({ to_select: true });
                } catch (error) {
                    console.error('Error al obtener remitentes', error);
                }
            },
            async getCarpetas() {
                try {
                    this.carpetas = await apiService.getCarpetasBoletines({ to_select: true });
                } catch (error) {
                    console.error('Error al obtener las carpetas', error);
                }
            },
            async getGrupos() {
                try {
                    this.grupos = await apiService.getGrupos( { to_select: true } );
                } catch (error) {
                    console.error('Error al obtener los subscriptores', error);
                }
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if (isValid) {
                    this.$emit('update:boletin', this.boletinLocal);
                    this.$emit('finalizarPasoUno');
                }
            }
        },
        created() {
            this.getRemitentes();
            this.getCarpetas();
            this.getGrupos();
        }
    }
</script>